/**
 * toast의 위치를 파악하기 위한 상수 값들을 정리합니다.
 */
export const FIXED_BOTTOM_HEIGHT = {
  BOTTOM_NAVIGATION: 56,
  CUSTOMIZING_GO_TO_CONFIRM_CTA: 80,
  CART_CTA: 72,
  CART_CTA_WITH_DESCRIPTION: 94.4,
} as const;
